module.exports = __webpack_public_path__ + "static/img/chuzhongyuwen.a142ab7a.jpg";